const ru = {
  brand: "E2 Care",
  tagline: "Спокойный, связанный уход.",
  nav_dashboard: "Панель",
  nav_residents: "Пациенты",
  nav_patients: "Пациенты",
  nav_rooms: "Комнаты",
  nav_devices: "Устройства",
  nav_events: "События",
  nav_alerts: "Оповещения",
  nav_users: "Команда",
  nav_settings: "Настройки",
  nav_admin: "Администрирование",
  nav_signout: "Выйти",
  topbar_search_placeholder: "Поиск пациентов, комнат, устройств…",
  admin_super_only: "Только суперадминистраторы могут управлять организациями.",
  admin_admin_only: "Только администраторы имеют доступ к этой странице.",
  admin_tab_orgs: "Организации",
  admin_tab_users: "Пользователи",
  admin_tab_patients: "Пациенты",
  admin_tab_rooms: "Комнаты",
  admin_tab_buildings: "Здания",
  admin_tab_devices: "Устройства",
  admin_tab_alerts: "Оповещения",
  admin_tab_qa: "Тестовые инструменты",
  admin_delete: "Удалить",
  admin_no_orgs_yet: "Пока нет организаций.",
  admin_field_name: "Имя",
  admin_field_email: "Эл. почта",
  admin_field_phone: "Телефон",
  admin_field_password: "Пароль",
  admin_field_role: "Роль",
  admin_field_type: "Тип",
  admin_field_timezone: "Часовой пояс",
  admin_field_address: "Адрес",
  admin_field_status: "Статус",
  admin_field_organization: "Организация",
  admin_password_keep: "Оставьте пустым, чтобы сохранить текущий",
  admin_field_birth_date: "Дата рождения",
  admin_field_room: "Комната",
  admin_field_room_none: "Не назначено",
  admin_field_photo: "URL фото",
  admin_field_photo_hint: "Вставьте публичный URL изображения — полная загрузка в версии 2.",
  admin_field_notes: "Заметки ухаживающего",
  admin_field_emergency_contact: "Основной экстренный контакт",
  admin_field_ec_name: "Имя",
  admin_field_ec_phone: "Телефон",
  admin_field_ec_relationship: "Родство",
  admin_field_mac: "MAC-адрес",
  admin_field_firmware: "Прошивка",
  admin_field_assignment: "Назначено",
  admin_field_assigned_room: "Назначенная комната",
  admin_field_assigned_patient: "Назначенный пациент",
  admin_field_assigned_hint: "Необязательно. Датчики обычно привязывают к комнате, браслеты — к пациенту.",
  admin_field_sensor_target: "Установлен на",
  admin_field_sensor_target_hint: "Сообщает системе, следит ли этот датчик за дверью или окном.",
  sensor_target_door: "Дверь",
  sensor_target_window: "Окно",
  sensor_target_unset: "Не настроено",
  admin_field_sensor_label: "Метка датчика",
  admin_field_sensor_label_hint: "Удобное имя, отображаемое в оповещениях и событиях — напр. «Входная дверь», «Окно ванной».",
  admin_field_building: "Здание",
  admin_field_building_required: "Комната должна принадлежать зданию.",
  room_openings: "Проёмы",
  room_no_openings: "В этой комнате пока не установлены датчики дверей или окон.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Последнее изменение",
  admin_field_description: "Описание",
  admin_field_severity: "Важность",
  admin_field_patient: "Пациент",
  admin_field_device: "Устройство",
  admin_field_message: "Сообщение",
  admin_orgs_title: "Организации",
  admin_orgs_sub: "Создавайте, редактируйте и архивируйте арендаторов E2 Care.",
  admin_orgs_count: "организации",
  admin_org_new: "Новая организация",
  admin_org_new_title: "Новая организация",
  admin_org_edit_title: "Редактировать организацию",
  admin_org_created: "Организация создана.",
  admin_org_updated: "Организация обновлена.",
  admin_org_deleted: "Организация заархивирована.",
  admin_org_delete_title: "Заархивировать организацию?",
  admin_org_delete_confirm: "Это скроет «{name}» из списков. При необходимости её можно восстановить из базы данных.",
  admin_users_title: "Пользователи",
  admin_users_sub_super: "Управляйте всеми учётными записями пользователей у всех арендаторов.",
  admin_users_sub_org: "Управляйте учётными записями пользователей для {org}.",
  admin_user_new: "Новый пользователь",
  admin_user_new_title: "Новый пользователь",
  admin_user_edit_title: "Редактировать пользователя",
  admin_user_created: "Пользователь создан.",
  admin_user_updated: "Пользователь обновлён.",
  admin_user_deleted: "Пользователь заархивирован.",
  admin_user_delete_title: "Заархивировать пользователя?",
  admin_user_delete_confirm: "«{name}» потеряет доступ. Активные сеансы не завершаются.",
  admin_user_memberships: "Членство в организациях",
  admin_patients_title: "Пациенты",
  admin_patients_sub_super: "Управляйте всеми карточками пациентов у всех арендаторов.",
  admin_patients_sub_org: "Управляйте карточками пациентов в {org}.",
  admin_patient_new: "Новый пациент",
  admin_patient_new_title: "Новый пациент",
  admin_patient_edit_title: "Редактировать пациента",
  admin_patient_created: "Пациент создан.",
  admin_patient_updated: "Пациент обновлён.",
  admin_patient_deleted: "Пациент заархивирован.",
  admin_patient_delete_title: "Заархивировать пациента?",
  admin_patient_delete_confirm: "«{name}» будет скрыт из списков. Связи с командой ухода и семьёй сохранены.",
  admin_rooms_title: "Комнаты",
  admin_rooms_sub_super: "Настраивайте комнаты у всех арендаторов.",
  admin_rooms_sub_org: "Настраивайте комнаты в {org}.",
  admin_room_new: "Новая комната",
  admin_room_new_title: "Новая комната",
  admin_room_edit_title: "Редактировать комнату",
  admin_room_created: "Комната создана.",
  admin_room_updated: "Комната обновлена.",
  admin_room_deleted: "Комната заархивирована.",
  admin_room_delete_title: "Заархивировать комнату?",
  admin_room_delete_confirm: "«{name}» будет скрыта. Существующие пациенты сохраняют ссылку assigned_room_id.",
  admin_devices_title: "Устройства",
  admin_devices_sub_super: "Подготавливайте устройства Moko у всех арендаторов.",
  admin_devices_sub_org: "Подготавливайте устройства Moko в {org}.",
  admin_device_new: "Новое устройство",
  admin_device_new_title: "Новое устройство",
  admin_device_edit_title: "Редактировать устройство",
  admin_device_created: "Устройство создано.",
  admin_device_updated: "Устройство обновлено.",
  admin_device_deleted: "Устройство заархивировано.",
  admin_device_delete_title: "Заархивировать устройство?",
  admin_device_delete_confirm: "Устройство {mac} будет скрыто. Прошлые события и оповещения остаются в истории.",
  admin_buildings_title: "Здания",
  admin_buildings_sub_super: "Группируйте комнаты по физическому зданию / крылу у всех арендаторов.",
  admin_buildings_sub_org: "Группируйте комнаты по физическому зданию / крылу в {org}.",
  admin_building_new: "Новое здание",
  admin_building_new_title: "Новое здание",
  admin_building_edit_title: "Редактировать здание",
  admin_building_created: "Здание создано.",
  admin_building_updated: "Здание обновлено.",
  admin_building_deleted: "Здание заархивировано.",
  admin_building_delete_title: "Заархивировать здание?",
  admin_building_delete_confirm: "«{name}» будет скрыто. Комнаты сохраняют ссылку corpus_id.",
  admin_qa_title: "Тестовые инструменты",
  admin_qa_sub: "Внедряйте события / оповещения, чтобы протестировать панель, рассылку оповещений и каналы уведомлений без использования реальных устройств Moko.",
  admin_qa_event_title: "Внедрить тестовое событие",
  admin_qa_event_sub: "Имитирует вебхук устройства Moko. Бэкенд запустит свой конвейер рассылки оповещений, как если бы событие пришло с реального оборудования.",
  admin_qa_alert_title: "Внедрить тестовое оповещение",
  admin_qa_alert_sub: "Пропускает слой событий и записывает оповещение напрямую. Используйте для проверки колокольчика, списка и рассылки Slack/Telegram.",
  admin_qa_inject_event: "Внедрить событие",
  admin_qa_inject_alert: "Внедрить оповещение",
  admin_qa_event_done: "Событие внедрено. Следите за страницей События и панелью.",
  admin_qa_alert_done: "Оповещение внедрено. Следите за колокольчиком.",
  admin_qa_disclaimer: "Эти конечные точки следует отключить или пометить флагом в продакшене.",
  admin_alerts_title: "Политика оповещений",
  admin_alerts_sub: "Правила оповещений для всей {org}. Применяются к каждому пациенту этого арендатора.",
  admin_alerts_quiet_title: "Тихие часы",
  admin_alerts_quiet_desc: "Определите, когда эта организация находится в «ночном режиме». Полезно для более тихой маршрутизации некритичных оповещений.",
  admin_alerts_quiet_hint: "Время интерпретируется в локальном часовом поясе организации. Диапазон может переходить через полночь (напр. 22:00 → 06:00).",
  admin_alerts_night_start: "Ночь начинается",
  admin_alerts_night_end: "Ночь заканчивается",
  admin_alerts_load_failed: "Загрузить политику оповещений",
  admin_alerts_save_failed: "Сохранить политику оповещений",
  admin_alerts_saved: "Политика оповещений сохранена.",
  admin_alerts_clear_title: "Очистить активные оповещения",
  admin_alerts_clear_desc: "Подтвердите все открытые оповещения этой организации одним кликом.",
  admin_alerts_clear_hint: "Полезно после запланированных учений или неправильно настроенного датчика, вызвавшего волну ложных срабатываний. Подтверждённые оповещения остаются в истории.",
  admin_alerts_ack_all_button: "Подтвердить все",
  admin_alerts_ack_all_title: "Подтвердить все активные оповещения?",
  admin_alerts_ack_all_confirm: "Это отметит как подтверждённое каждое открытое оповещение в {org}. Это действие нельзя отменить.",
  admin_alerts_ack_all_done: "Подтверждено {count} оповещений.",
  admin_alerts_ack_all_done_generic: "Все активные оповещения подтверждены.",
  admin_alerts_ack_all_failed: "Подтвердить все оповещения",
  org_type_nursing_home: "Дом престарелых",
  org_type_assisted_living: "Жильё с поддержкой",
  org_type_hospital: "Больница",
  org_type_home_care: "Уход на дому",
  role_admin: "Администратор",
  role_caregiver: "Ухаживающий",
  role_family: "Семья",
  status_active: "активен",
  status_inactive: "неактивен",
  confirm: "Подтвердить",
  sign_in: "Войти",
  signed_in: "Вход выполнен",
  sign_up: "Зарегистрироваться",
  email: "Эл. почта",
  password: "Пароль",
  full_name: "Полное имя",
  create_account: "Создать учётную запись",
  no_account: "Ещё нет учётной записи?",
  have_account: "Уже есть учётная запись?",
  login_welcome: "С возвращением",
  login_sub: "Войдите, чтобы продолжить наблюдение за вашими подопечными.",
  register_welcome: "Присоединяйтесь к E2 Care",
  register_sub: "Создайте своё рабочее пространство ухаживающего менее чем за минуту.",
  total_residents: "Пациенты",
  active_devices: "Активные устройства",
  open_alerts: "Открытые оповещения",
  offline_gateways: "Устройства офлайн",
  falls_7d: "Падения (7 дн)",
  sos_7d: "SOS (7 дн)",
  low_battery: "Низкий заряд",
  critical_residents: "Критические",
  status_ok: "Всё в порядке",
  status_warning: "Внимание",
  status_critical: "Критический",
  status_online: "В сети",
  status_offline: "Не в сети",
  search: "Поиск",
  filter: "Фильтр",
  all: "Все",
  refresh: "Обновить",
  loading: "Загрузка…",
  no_results: "Здесь пока ничего нет.",
  view_profile: "Просмотреть профиль",
  showing_n_of_m: "Показано {n} из {m}",
  load_more: "Загрузить ещё",
  auto_refresh: "В реальном времени · автообновление",
  auto_refresh_paused: "Приостановлено (активна загрузка ещё)",
  updated_just_now: "Обновлено только что",
  updated_n_sec_ago: "Обновлено {n} с назад",
  updated_n_min_ago: "Обновлено {n} мин назад",
  acknowledge: "Подтвердить",
  acknowledged: "Подтверждено",
  ack_all: "Подтвердить все",
  ack_all_confirm: "Подтвердить все {count} активные оповещения?",
  ack_all_running: "Подтверждение…",
  ack_all_done: "Подтверждено {count} оповещений.",
  ack_all_partial: "{ok} подтверждено · {fail} не удалось.",
  last_seen: "Был(а) в сети",
  battery: "Батарея",
  signal: "Сигнал",
  firmware: "Прошивка",
  room: "Кв. / Комната",
  age: "Возраст",
  emergency_contact: "Экстренный контакт",
  notes: "Заметки",
  assigned_devices: "Назначенные устройства",
  recent_events: "Последние события",
  timeline_24h: "Последние 24 часа",
  delivery_status: "Статус доставки",
  acknowledged_by: "Подтверждено",
  dashboard_title: "Обзор дома",
  dashboard_sub: "Быстрый обзор всего, что происходит в домах, за которыми вы ухаживаете.",
  residents_title: "Пациенты",
  residents_sub: "Люди, за которыми вы сейчас наблюдаете.",
  devices_title: "Устройства",
  devices_sub: "Датчики и метки.",
  devices_sub_admin: "Шлюзы, датчики и метки.",
  events_title: "События в реальном времени",
  events_sub: "Хронологическая лента с каждого подключённого устройства.",
  alerts_title: "Оповещения",
  alerts_sub: "Уведомления, эскалированные семье и ухаживающим.",
  settings_title: "Настройки",
  settings_sub: "Ваши предпочтения и правила уведомлений.",
  users_title: "Команда",
  users_sub: "Ухаживающие, семья и администраторы с доступом.",
  falls_chart_title: "Падения и SOS — последние 7 дней",
  recent_alerts_title: "Последние критические оповещения",
  no_alerts: "Нет открытых оповещений. Все в безопасности.",
  event_fall: "Обнаружено падение",
  event_sos: "Нажата кнопка SOS",
  event_door_open: "Дверь открыта",
  event_door_close: "Дверь закрыта",
  event_inactivity: "Продолжительное бездействие",
  event_low_battery: "Низкий заряд",
  event_offline: "Устройство офлайн",
  event_online: "Устройство снова в сети",
  event_heartbeat: "Сигнал активности",
  event_button_press: "Нажата кнопка",
  device_gateway: "Шлюз Bluetooth",
  device_door_sensor: "Датчик двери",
  device_bracelet: "Браслет",
  device_unknown: "Неизвестное устройство",
  language: "Язык",
  notifications: "Уведомления",
  quiet_hours: "Тихие часы",
  escalation: "Политика эскалации",
  just_now: "только что",
  rel_prefix: "",
  min_ago: "мин назад",
  h_ago: "ч назад",
  d_ago: "дн назад",
  demo_hint: "Демо-аккаунт: admin@e2care.lv / Care2024!",
  open_menu: "Открыть меню",
  close_menu: "Закрыть меню",
  care_team: "Команда ухода",
  family_members: "Семья",
  no_caregivers: "Ухаживающие ещё не назначены.",
  no_family: "Члены семьи ещё не связаны.",
  add_caregiver: "Добавить ухаживающего",
  add_family: "Добавить члена семьи",
  select_user: "Выберите пользователя…",
  cancel: "Отмена",
  add: "Добавить",
  remove: "Удалить",
  save: "Сохранить",
  relationship: "Родство",
  relationship_son: "Сын",
  relationship_daughter: "Дочь",
  relationship_spouse: "Супруг(а)",
  relationship_other: "Другое",
  notify_via: "Уведомлять через",
  call_contact: "Позвонить контакту",
  view_resident: "Открыть профиль",
  address: "Адрес",
  admin_only_section: "Инструменты администратора",
  rooms_title: "Комнаты",
  rooms_sub: "Каждая комната под вашим наблюдением — пациенты, устройства и текущее состояние.",
  room_name: "Комната",
  room_type: "Тип",
  room_type_private_room: "Отдельная комната",
  room_type_shared_room: "Общая комната",
  room_type_apartment: "Квартира",
  room_type_corridor: "Коридор",
  room_type_common_area: "Общая зона",
  room_floor: "Этаж",
  room_state: "Текущее состояние",
  door: "Дверь",
  window: "Окно",
  door_open_state: "Открыто",
  door_closed_state: "Закрыто",
  door_unknown_state: "Неизвестно",
  room_no_devices: "В этой комнате пока нет устройств.",
  room_no_patients: "В эту комнату пока не назначены пациенты.",
  room_patients: "Пациенты в комнате",
  room_devices: "Устройства в комнате",
  room_activity: "Хронология активности",
  rooms_filter_all_types: "Все типы",
  widget_active_alerts: "Активные оповещения",
  widget_active_alerts_sub: "Критические, нерешённые и подтверждённые",
  widget_patients_status: "Статус пациентов",
  widget_devices_health: "Состояние устройств",
  widget_room_activity: "Активность комнат",
  widget_recent_events: "Лента событий в реальном времени",
  widget_connectivity: "Связь",
  metric_critical: "Критические",
  metric_unresolved: "Нерешённые",
  metric_acknowledged_count: "Подтверждённые",
  metric_total: "Всего",
  metric_active: "Активные",
  metric_online: "В сети",
  metric_offline: "Не в сети",
  metric_ota_pending: "OTA в ожидании",
  metric_battery_warn: "Низкий заряд",
  metric_doors_open: "Открытые двери",
  metric_windows_open: "Открытые окна",
  metric_signal_avg: "Ср. сигнал",
  metric_last_comm: "Последняя связь",
  metric_packets: "Пакеты / час",
  view_all: "Показать все",
  status_new: "Новый",
  status_acknowledged: "Подтверждённый",
  status_resolved: "Решённый",
  status_resolved_local: "Решён (локально)",
  resolve: "Решить",
  add_note: "Добавить заметку",
  save_note: "Сохранить заметку",
  resolve_local_badge: "только это устройство",
  resolve_local_hint: "Отмечает оповещение как решённое только в вашем браузере. Сервер и другие члены команды по-прежнему видят его открытым.",
  note_placeholder: "Добавьте контекст для команды…",
  notes_count: "{n} заметок",
  device_detail: "Сведения об устройстве",
  device_diagnostics: "Диагностика",
  device_firmware_history: "История прошивки",
  device_ota_config: "Конфигурация OTA",
  device_ota_status: "Статус OTA",
  device_signal: "Качество сигнала",
  device_mac: "MAC-адрес",
  device_serial: "Серийный номер",
  fall_sensitivity: "Чувствительность обнаружения падения",
  transmission_interval: "Интервал передачи",
  low_battery_threshold: "Порог низкого заряда",
  ota_idle: "Простой",
  ota_pending: "В ожидании",
  ota_deploying: "Развёртывание",
  ota_failed: "Ошибка",
  events_filter_severity: "Важность",
  events_filter_room: "Комната",
  events_filter_patient: "Пациент",
  events_filter_device: "Устройство",
  severity_info: "Инфо",
  severity_warning: "Предупреждение",
  severity_critical: "Критический",
  telegram_title: "Оповещения Telegram",
  telegram_desc: "Получайте оповещения в Telegram для назначенных вам подопечных.",
  telegram_connect: "Подключить Telegram",
  telegram_connected: "Telegram подключён",
  telegram_connected_as: "Подключено к Telegram как {name}",
  telegram_connect_success: "Telegram успешно подключён",
  telegram_connect_error: "Не удалось подключить Telegram. Попробуйте ещё раз.",
  telegram_missing_bot: "Бот Telegram не настроен. Установите REACT_APP_TELEGRAM_BOT в файле env.",
  telegram_disconnect: "Отключить",
  telegram_disconnect_success: "Telegram отключён.",
  telegram_disconnect_error: "Не удалось отключить Telegram. Попробуйте ещё раз.",
  telegram_already_linked: "Этот аккаунт Telegram уже привязан к другому пользователю e2-care.",
  telegram_switch_q: "Использовать другой аккаунт Telegram?",
  telegram_switch_intro: "Telegram запоминает, какой аккаунт вошёл на всех сайтах. Чтобы использовать другой:",
  telegram_switch_step1: "Откройте Telegram Web и выйдите из текущего аккаунта.",
  telegram_switch_step2: "Вернитесь сюда и перезагрузите кнопку ниже, затем войдите другим аккаунтом.",
  telegram_open_web: "Открыть Telegram Web",
  telegram_reload_widget: "Я вышел — перезагрузить кнопку",
  lang_autodetected_toast: "Определён ваш язык как {language}. Вы можете изменить его в Настройках.",
  admin_view_active: "Активные",
  admin_view_archived: "Заархивированные",
  admin_restore: "Восстановить",
  admin_restored: "Восстановлено.",
  admin_hard_delete: "Удалить навсегда",
  admin_hard_delete_title: "Удалить навсегда?",
  admin_hard_delete_confirm: "Это навсегда удалит «{name}» из базы данных. Это действие нельзя отменить.",
  admin_hard_deleted: "Удалено навсегда.",
  admin_no_archived: "Нет заархивированных элементов.",
  language_desc: "Используется для интерфейса приложения и ваших уведомлений Telegram + push.",
  language_saved: "Язык обновлён.",
  language_error: "Не удалось обновить язык. Попробуйте ещё раз.",
  admin_field_language: "Язык",
  edit: "Редактировать",
  generic_error: "Что-то пошло не так. Попробуйте ещё раз.",
  caregiver_added: "Ухаживающий добавлен.",
  caregiver_removed: "Ухаживающий удалён.",
  family_added: "Член семьи добавлен.",
  family_removed: "Член семьи удалён.",
  menu: "Меню",
  dl_companion_app: "Приложение-компаньон",
  dl_hero_title: "E2 Care для Android",
  dl_hero_sub: "Установите приложение-компаньон на телефон с Moko, чтобы ретранслировать оповещения, настраивать устройства и оставаться на связи с командой ухода — даже когда панель закрыта.",
  dl_android_apk: "APK Android",
  dl_version_loading: "загрузка версии…",
  dl_released: "Выпущено {date}",
  dl_download_apk: "Скачать APK",
  dl_unavailable: "Недоступно",
  dl_preparing: "Подготовка…",
  dl_manifest_error: "Не удалось загрузить манифест. Попробуйте обновить — если проблема сохраняется, сервер сборки может переразвёртываться.",
  dl_whats_new: "Что нового",
  dl_installing_title: "Установка на телефон",
  dl_step1: "Нажмите «Скачать APK» выше. Ваш браузер может предупредить, что файлы APK могут навредить устройству — это предупреждение нормально для любого установщика, скачанного вне Play Store.",
  dl_step2: "Откройте скачанный файл. Android попросит разрешить установку из этого браузера в первый раз — включите разрешение и вернитесь.",
  dl_step3: "Нажмите «Установить», затем «Открыть» по завершении.",
  dl_step4: "Войдите, используя свои учётные данные E2 Care.",
  dl_iphone_note: "Версия для iPhone появится позже. Пока используйте веб-панель.",
  dl_back_to_dashboard: "Назад к панели",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Смена организации очищает текущее назначение комнаты и пациента.",
  admin_view_full: "Полный список",
  device_filter_assignment: "Назначение",
  device_filter_patient: "Назначено пациенту",
  device_filter_room: "Назначено комнате",
  device_filter_unassigned: "Не назначено",
  admin_all_orgs: "Все организации",
  pagination_prev: "Предыдущая",
  pagination_next: "Следующая",
  pagination_per_page: "На странице",
  pagination_page_of: "Страница {page} из {pages}",
  pagination_total: "Всего {total}",
  event_charging: "Зарядка начата",
  event_sos_cancel: "SOS отменён",
  event_call: "SOS-вызов",
  device_personal_alarm: "Персональная тревога",
  device_charging: "Зарядка",
  device_location: "Местоположение",
  device_current_location: "Текущее местоположение",
  device_no_location: "Местоположение ещё не передано.",
  device_location_source: "Источник",
  device_location_updated: "Обновлено",
  device_track_1h: "1 ч",
  device_track_24h: "24 ч",
  device_track_7d: "7 дн",
  device_track_last: "Последняя позиция",
  device_located: "Найдено",
  map_sos: "Сигнал SOS",
  map_fall: "Обнаружено падение",
  map_current: "Текущая позиция",
  alert_timeline: "Хронология тревоги",
  alert_trigger: "Триггер",
  alert_calls: "Звонки",
  alert_view_timeline: "Посмотреть хронологию",
  alert_no_deliveries: "Уведомления ещё не отправлены.",
  alert_cancelled_on_device: "SOS был отменён на устройстве — тревога остаётся открытой, пока её не закроет сиделка.",
  call_answered: "Отвечен",
  call_missed: "Пропущен",
  reopen: "Открыть снова",
  reopened: "Тревога открыта снова",
  live: "В реальном времени",
  nav_home: "Главная",
  family_home_kicker: "Семейный вид",
  family_home_title: "Ваши близкие",
  family_greeting: "Здравствуйте",
  family_home_sub: "Спокойный обзор того, как дела у каждого.",
  family_status_ok: "в порядке",
  family_status_attention: "требует внимания",
  family_all_calm: "Сейчас всё спокойно.",
  family_attention_sub: "Давайте проверим, как он — подробности ниже.",
  family_last_seen: "последний раз в сети",
  family_latest_alert: "Последняя тревога",
  family_no_alerts: "Недавних тревог нет — всё хорошо.",
  family_view_details: "Подробнее",
  family_no_device: "Персональная тревога ещё не привязана.",
  status_never_reported: "Никогда не сообщал",
  mv_title: "Движение",
  mv_sub: "С {n} датчика(ов) движения · 5-минутные окна",
  mvo_title: "Движение с первого взгляда",
  mvs_moving: "{name} на ногах",
  mvs_moving_sub: "Движение {when}",
  mvs_rest: "{name} отдыхает",
  mvs_rest_sub: "Последнее движение {when}",
  mvs_rest_sub_none: "Нет движения за последние 30 дней",
  mvs_quiet: "{name}: нет движения дольше обычного",
  mvs_quiet_sub: "Нет движения уже {dur}. Возможно, стоит позвонить.",
  mvs_short_quiet: "Долго без движения",
  mvs_room_moving: "Кто-то двигается в помещении {name}",
  mvs_room_rest: "В помещении {name} спокойно",
  mvs_room_quiet: "В помещении {name} нет движения дольше обычного",
  mvs_sensor: "Датчик движения не передаёт данные",
  mvs_sensor_sub: "Это касается датчика, а не {name}. Последний сигнал {when}.",
  mvs_nodata: "Данных о движении пока нет",
  mvs_nodata_sub: "Датчик движения пока ничего не передал.",
  mvd_title: "Последние 24 часа",
  mvd_moving: "Движение",
  mvd_resting: "Отдых",
  mvd_nosignal: "Нет сигнала",
  mvd_night: "Ночь",
  mvd_now: "Сейчас",
  mvn_title: "Последние 7 ночей",
  mvn_last_night: "Прошлой ночью",
  mvn_last_short: "Вчера",
  mvn_calm: "Спокойная",
  mvn_restless: "Беспокойная",
  mvn_still: "Очень тихая",
  mvn_silent: "Датчик молчал",
  mvn_nodata: "Нет данных",
  mvn_s_calm_none: "Спокойная ночь, без движения с {from} до {to}.",
  mvn_s_calm_once: "Спокойная ночь, один подъём около {at}.",
  mvn_s_calm_many: "Спокойная ночь, подъёмов: {n}, первый около {first}, последний около {last}.",
  mvn_s_restless: "Беспокойная ночь, подъёмов: {n} с {first} до {last}.",
  mvn_s_still: "Очень тихая ночь, меньше движения, чем обычно. Самый долгий отдых {dur}.",
  mvn_s_still_moved: "Очень тихая ночь, движение только около {at}. Самый долгий отдых {dur}.",
  mvn_s_silent: "Датчик почти молчал, поэтому мы не можем сказать, как прошла ночь.",
  mvn_s_nodata: "Нет данных о движении за эту ночь.",
  mv_state_moving: "Движение",
  mv_state_still: "Отдых",
  mv_state_inactive: "Неактивен",
  mv_state_silent: "Датчик не передаёт данные",
  mv_state_never: "Никогда не сообщал",
  mv_state_nodata: "Данных пока нет",
  mv_state_no_sensor: "Нет датчика движения",
  mv_last_movement: "Последнее движение",
  mv_last_sample: "Последний сигнал датчика",
  mv_none_in_retention: "Нет за последние 30 дней",
  mv_silent_hint: "Нет данных более {min} мин — проверьте датчик или его шлюз. Это неисправность устройства, а не неподвижность.",
  mv_inactive_hint: "Нет движения более {min} мин, хотя датчик продолжает передавать данные.",
  mv_history: "История движения",
  mv_history_empty: "За этот период данных о движении пока нет.",
  mv_not_reporting: "Не передаёт данные",
  mv_no_movement: "Нет движения",
  mv_detections: "обнаружений движения",
  mv_legend_motion: "Обнаружения движения",
  mv_legend_gap: "Не передаёт данные",
  mv_retention_note: "История хранится 30 дней",
  mv_strip_title: "Движение в реальном времени",
  mv_strip_sub: "{n} датчик(ов) движения",
  mv_unassigned: "Неназначенный датчик",
  admin_alerts_timezone: "Часовой пояс организации",
  admin_alerts_timezone_invalid: "Выберите действительный часовой пояс IANA.",
  admin_alerts_night_wrap_hint: "Ночные часы длятся с {start} до {end} следующего утра ({tz}), то есть после {start} или до {end}.",
  admin_alerts_night_same_day_hint: "Ночные часы длятся с {start} до {end} в тот же день ({tz}).",
  admin_alerts_night_equal: "Начало и конец не могут совпадать.",
  admin_alerts_inactivity_label: "Порог неактивности",
  admin_alerts_inactivity_question: "Двигался ли этот человек? Минуты без движения, после которых это становится поводом для тревоги.",
  admin_alerts_silence_label: "Порог молчания устройства",
  admin_alerts_silence_question: "На связи ли этот датчик? Минуты без единого сигнала, после которых это считается неисправностью устройства, а не неактивным жильцом.",
  admin_alerts_minutes: "минут",
  admin_alerts_threshold_invalid: "Введите целое число больше 0.",
  admin_alerts_thresholds_provisional: "Начальные значения (180 / 30 мин) ещё не настроены — адаптируйте их к своим жильцам.",
  admin_tab_gateways: "Шлюзы",
  gw_title: "Шлюзы",
  gw_status_deactivated: "Отключён",
  gw_scope_pending: "Шлюзы вашей организации появятся здесь после обновления бэкенда.",
  gw_none_for_org: "К этой организации пока не привязан ни один шлюз.",
  gw_col_room: "Комната",
  gw_unassigned: "Не назначен",
  gw_never: "Никогда",
  gw_edit_title: "Изменить шлюз",
  gw_new_title: "Новый шлюз",
  gw_super_field: "Изменить может только суперадминистратор",
  gw_mac_invalid: "Введите 12 шестнадцатеричных символов, напр. AA:BB:CC:DD:EE:FF",
  gw_hw_type: "Тип оборудования",
  gw_notes: "Заметки",
  gw_manage_sub: "BLE-хабы, передающие данные датчиков: состояние, организация и комната. Молчащий шлюз заставляет «молчать» все датчики за ним.",
  gw_filter_all: "Все организации",
  gw_new: "Новый шлюз",
  gw_col_assignment: "Организация · Комната",
  gw_backend_pending: "Нужно обновление бэкенда, которое ещё не развернуто.",
  gw_save_failed: "Сохранить шлюз",
  gw_created: "Шлюз создан",
  gw_saved: "Шлюз сохранён",
  gw_reactivated: "Шлюз снова включён",
  gw_deactivated: "Шлюз отключён",
  gw_reactivate: "Включить снова",
  gw_deactivate: "Отключить",
  gw_reactivate_title: "Снова включить {name}?",
  gw_deactivate_title: "Отключить {name}?",
  gw_reactivate_desc: "Он снова будет учитываться в состоянии и оповещениях.",
  gw_deactivate_desc: "Он перестаёт учитываться в состоянии и оповещениях. История сохраняется, его можно снова включить в любой момент.",
  gw_heard_title: "Слышимые устройства",
  gw_heard_sub: "Датчики, переданные этим шлюзом за последние 24 часа.",
  gw_heard_none: "За последние 24 часа устройств нет.",
  gw_heard_unknown: "Неизвестные устройства",
  gw_msgs_short: "сообщ.",
  gw_avg: "сред.",
  gw_samples_short: "замеров",
  gw_not_found: "Шлюз не найден или вам не виден.",
  gw_one: "Шлюз",
  gw_manage_link: "Управлять в Администрировании",
  gw_rssi_range: "Диапазон сигнала",
  gw_longest_gap: "Самый долгий перерыв",
  gw_config_push: "Последняя отправка конфигурации",
  gw_sub: "BLE-хабы, передающие данные датчиков. Только просмотр — молчащий шлюз делает молчащими все датчики за ним.",
  gw_super_only: "Состояние шлюзов доступно только суперадминистраторам.",
  gw_load_failed: "Загрузка шлюзов",
  gw_status_reporting: "Передаёт",
  gw_status_silent: "Молчит",
  gw_status_never_seen: "Никогда не виден",
  gw_returned: "Вернулся после перерыва {h} ч (закончился {at})",
  gw_count_reporting: "{n} передают",
  gw_count_silent: "{n} молчат",
  gw_count_never: "{n} никогда не видны",
  gw_count_deactivated: "отключено: {n}",
  gw_window: "Устаревший после {h} ч без сообщений",
  gw_col_name: "Шлюз",
  gw_col_status: "Состояние",
  gw_col_msgs: "Сообщения 24 ч",
  gw_col_discard: "Отброшено",
  gw_last_message: "Последнее сообщение",
  gw_devices_seen: "Видимые устройства",
  gw_hours_active: "Активные часы",
  gw_unregistered_title: "Передаёт без записи в реестре",
  gw_unregistered_desc: "Эти идентификаторы есть в активности шлюзов, но не имеют записи (напр., устройство, передающее под IMEI). Итоги из двух источников могут обоснованно различаться.",
  nav_reports: "Отчёты",
  rep_night_title: "Ночная сводка",
  rep_night_desc: "Утренняя сводка движения каждого жильца в ночные часы организации и периодов молчания датчиков.",
  rep_last_night: "Прошлая ночь",
  rep_nights_ago: "{n} ночи назад",
  rep_policy_fallback: "ночные часы по умолчанию (политика недоступна)",
  rep_movement: "Движение",
  rep_windows: "{n} активных 5-мин окон",
  rep_no_movement: "Нет движения",
  rep_first_movement: "Первое движение",
  rep_longest_still: "Самая долгая неподвижность",
  rep_silences: "Молчание датчика",
  rep_none: "Нет",
  rep_coverage: "{pct}% получено",
  rep_night_note: "Время указано в часовом поясе организации. Неподвижность учитывается только пока датчик передаёт данные; периоды молчания от порога молчания перечислены отдельно.",
  dh_reporting_title: "Состояние передачи",
  dh_never_reported_desc: "Зарегистрировано, но ни разу не передавало данные. Это незавершённая установка, а не устройство офлайн.",
  dh_interval_still: "Измеренный интервал (в покое)",
  dh_interval_moving: "Измеренный интервал (в движении)",
  dh_interval_samples: "Образцы измерений",
  dh_interval_unmeasured: "Измеренного интервала пока нет — применяется порог молчания организации.",
  dh_interval_note: "Интервалы измеряются по полученным сообщениям, а не по настроенному значению.",
  rep_dur_h_min: "{h} ч {m} мин",
  rep_dur_min: "{m} мин",
  rep_shared_room: "Общая комната — может включать движение других",
  rep_no_data_night: "Нет данных за эту ночь — датчик не передавал данные (или ещё не был установлен).",
  nav_buildings: "Здания",
  imei_label: "IMEI",
  imei_hint: "15 цифр, напечатанных на обороте устройства",
  imei_length: "IMEI содержит 15 цифр",
  imei_invalid: "Этот IMEI недействителен. Проверьте цифры",
  imei_resident_note: "Тревожная кнопка сопровождает жильца, поэтому не привязывается к комнате.",
  imei_online_hint: "Устройство появляется онлайн после первого сигнала, примерно через 5 минут после включения.",
  forgot_link: "Забыли пароль? Нажмите здесь",
  forgot_title: "Сброс пароля",
  forgot_sub: "Введите email, и мы отправим ссылку для сброса пароля.",
  forgot_submit: "Отправить ссылку",
  forgot_sent: "Если учётная запись с этим email существует, мы отправили ссылку для сброса пароля. Проверьте почту.",
  forgot_back: "← Назад ко входу",
  reset_title: "Новый пароль",
  reset_sub: "Выберите новый пароль для учётной записи.",
  reset_new_password: "Новый пароль",
  reset_confirm_password: "Подтвердите пароль",
  reset_hint: "Не менее 8 символов.",
  reset_submit: "Обновить пароль",
  reset_success: "Пароль обновлён. Переход ко входу…",
  reset_too_short: "Пароль должен содержать не менее 8 символов.",
  reset_mismatch: "Пароли не совпадают.",
  reset_no_token: "Ссылка недействительна или отсутствует. Запросите новую на странице входа.",
  reset_failed: "Ссылка недействительна или устарела. Запросите новую.",
  admin_tab_device_types: "Типы устройств",
  admin_dt_title: "Типы устройств",
  admin_dt_sub: "Каталог моделей устройств. Переименуйте отображаемое название типа — внутренний ключ, IoT-сопоставление и синхронизация не меняются.",
  admin_dt_col_label: "Отображаемое название",
  admin_dt_col_key: "Внутренний ключ",
  admin_dt_col_category: "Категория",
  admin_dt_col_wearable: "Носимое",
  admin_dt_col_ble_sync: "BLE-синхронизация",
  admin_dt_col_ble_type_id: "ID типа BLE",
  admin_dt_wearable_yes: "Носит жилец",
  admin_dt_wearable_no: "Стационарное",
  admin_dt_ble_sync_on: "Требуется",
  admin_dt_ble_sync_off: "Выкл.",
  admin_dt_edit_label: "Изменить название",
  admin_dt_edit_title: "Переименовать",
  admin_dt_edit_desc: "Меняется только понятное название. Устройства, фильтры и интеграции продолжают использовать внутренний ключ «{key}».",
  admin_dt_label_saved: "Название обновлено.",
  admin_dt_label_required: "Название не может быть пустым.",
  admin_dt_load_failed: "Загрузка типов устройств",
  admin_dt_save_failed: "Обновление названия",
  admin_dt_readonly_hint: "Только суперадминистраторы могут переименовывать типы.",
  sensor_climate: "Климат",
  sensor_temperature: "Температура",
  sensor_humidity: "Влажность",
  sensor_last_reading: "Последнее измерение",
  sensor_history_title: "Температура и влажность (48 ч)",
  sensor_history_empty_title: "Измерений пока нет",
  sensor_history_empty_sub: "Назначьте этой комнате датчик H4 Pro, чтобы видеть историю климата.",
  admin_thresholds_title: "Пороги датчиков",
  admin_thresholds_desc: "Границы тревог по температуре и влажности для датчиков H4 Pro этой организации.",
  admin_thresholds_temp_min: "Мин. температура",
  admin_thresholds_temp_max: "Макс. температура",
  admin_thresholds_hum_min: "Мин. влажность",
  admin_thresholds_hum_max: "Макс. влажность",
  admin_thresholds_temp_invalid: "Мин. температура должна быть ниже макс.",
  admin_thresholds_hum_invalid: "Мин. влажность должна быть ниже макс.",
  admin_thresholds_hint: "Все четыре необязательны — оставьте поле пустым, чтобы не было тревоги для этой границы.",
  admin_thresholds_cooldown: "Пауза между тревогами",
  admin_thresholds_cooldown_placeholder: "По умолчанию: 30 мин",
  admin_thresholds_cooldown_help: "Минуты между повторными тревогами датчика. Оставьте пустым для системного значения (30 мин).",
  admin_thresholds_cooldown_invalid: "Пауза должна быть целым числом, не менее 1 минуты.",
  admin_thresholds_saved: "Пороги сохранены.",
  admin_thresholds_load_failed: "Загрузка порогов",
  admin_thresholds_save_failed: "Сохранение порогов",
  room_activity_view_all: "Все события",
  role_super_admin: "Суперадминистратор",
  assign_device: "Назначить устройство",
  select_device: "Выберите устройство…",
  admin_patient_no_devices_assigned: "Нет назначенных устройств.",
  admin_patient_no_wearables: "В этой организации нет доступных носимых устройств.",
  admin_patient_device_reassign: "переназначить",
  recent_critical_alerts_title: "Недавние критические тревоги",
  rooms_building_clear: "Сбросить фильтр",
  buildings_title: "Здания",
  buildings_sub: "Каждое здание под вашим наблюдением — с комнатами, жильцами и устройствами.",
  buildings_view_rooms: "Смотреть комнаты",
  wt_title: "Недельная тенденция",
  wt_desc: "Семь ночей рядом для каждого жильца — или общей комнаты — чтобы заметить беспокойные или необычно неподвижные ночи.",
  wt_baseline_note: "каждая ночь сравнивается с медианой строки за 7 ночей",
  wt_no_sensors: "Ни у одного жильца пока нет датчика движения.",
  wt_flag_restless: "Беспокойная",
  wt_flag_still: "Необычно неподвижная",
  wt_flag_nodata: "Нет данных",
  wt_flag_silent: "Датчик почти молчал",
  rep_sensor_silent: "Датчик передавал данные только {pct}% этой ночи. Пропуски означают, что датчик перестал передавать данные, а не что житель был неподвижен.",
  wt_legend_active: "Активные 5-мин окна",
  wt_legend_still: "Самая долгая неподвижность (ч)",
  fap_title: "Родственники могут обрабатывать оповещения",
  fap_desc: "Если включено, родственники могут подтверждать, закрывать, повторно открывать и комментировать оповещения своих подопечных в {org}.",
  note_saved: "Заметка сохранена",
  event_device_silent: "Датчик молчит",
  event_no_movement: "Нет движения",
  event_no_rise: "Нет движения после ночи",

  dur_lt_min: "меньше минуты",
  dur_min: "{m} мин",
  dur_h: "{h} ч",
  dur_h_min: "{h} ч {m} мин",
  am_fall: "Обнаружено падение",
  am_sos: "Нажата кнопка SOS",
  am_low_battery: "Низкий заряд батареи устройства",
  am_low_battery_dev: "Низкий заряд батареи: {device}",
  am_door: "Дверь открыта",
  am_door_in: "Дверь открыта: {place}",
  am_door_in_detail: "Дверь открыта: {place} ({detail})",
  am_window: "Окно открыто",
  am_window_in: "Окно открыто: {place}",
  am_window_in_detail: "Окно открыто: {place} ({detail})",
  am_silent: "Датчик движения в {place} не передаёт данные около {dur} — проверьте питание или шлюз",
  am_silent_nodur: "Датчик движения в {place} перестал передавать данные — проверьте питание или шлюз",
  am_nomove: "В {place} не обнаружено движения около {dur}",
  am_nomove_nodur: "В {place} не обнаружено движения",
  am_norise: "В {place} не обнаружено движения с окончания ночи (обычно встаёт к {time})",
  am_norise_notime: "В {place} не обнаружено движения с окончания ночи",
  amf_silent_res: "Датчик движения ({name}) не передаёт данные с {time}, поэтому сейчас движение не отслеживается.",
  amf_silent_room: "Датчик движения в {place} не передаёт данные с {time}, поэтому сейчас движение там не отслеживается.",
  amf_sensor_ok: "Датчик работает; он просто не видел, чтобы кто-то двигался.",
  amf_team: "Команда ухода предупреждена на своей панели.",
  amf_contact_device: "Вы указаны контактным лицом для этого устройства.",
  amf_contact_resident: "Вы указаны контактным лицом: {name}.",
  al_tab_care: "Уход",
  al_tab_maint: "Обслуживание",
  al_maint_hint: "Замолчавшие датчики и разряженные батареи: техническая работа, а не события ухода.",
  al_maint_empty: "Проблем с датчиками и батареями нет.",
  al_auto_closed: "Закрыто автоматически",
  al_auto_closed_reason: "Закрыто автоматически — {reason}",
  al_never_seen: "никто не видел его до закрытия",
  al_resolved_by: "Решено: {name}",
  al_reason_movement: "движение возобновилось",
  al_reason_sensor: "датчик снова передаёт данные",
  al_admin_only_ack: "Это оповещение может обработать только администратор, так как оно не связано с одним подопечным.",
  why_title: "Почему это сработало?",
  why_since_motion: "С последнего движения",
  why_since_sample: "С последних данных датчика",
  why_threshold: "Порог",
  why_up_by: "Обычно встаёт к",
  why_night: "Ночное окно",
  why_source: "Порог задан",
  why_src_org: "этой организацией",
  why_src_default: "значениями по умолчанию",
  why_state: "Состояние датчика",
  why_checked: "Проверено в",
  why_approx: "Проверки идут каждые 5 минут, поэтому время оповещений приблизительное.",
  mon_label: "Отслеживание движения",
  mon_active: "активно",
  mon_down: "нет данных",
  mon_down_since: "нет данных с {time}",
  admin_alerts_up_by_label: "Обычно встаёт к",
  admin_alerts_up_by_question: "Если между концом ночи и этим временем движения не видно, создаётся оповещение «нет движения с окончания ночи».",
  admin_alerts_up_by_invalid: "Должно быть позже конца ночи ({end}): это час, когда подопечные обычно уже встали, после ночи.",
  admin_alerts_up_by_format: "Введите время в формате ЧЧ:ММ.",
  admin_alerts_escalation_label: "Сообщить семье о замолчавшем датчике через",
  admin_alerts_escalation_question: "Персонал видит замолчавший датчик сразу. Семье сообщают, только если по истечении этого времени проблема не решена (сразу, если в организации нет сиделок).",
  admin_alerts_cooldown_note: "После закрытия оповещения то же оповещение может вернуться, когда порог будет снова превышен. Утреннее оповещение срабатывает не чаще раза в день.",
  admin_alerts_stored_invalid: "Сохранённое время ({up}) не позже конца ночи ({end}), поэтому утренние оповещения не работают, и эту политику нельзя сохранить, пока это не исправлено.",
  admin_alerts_defaults_badge: "Значения по умолчанию",

  fap_auto_on: "Автоматически: включено, так как в организации нет сиделок.",
  fap_auto_off: "Автоматически: выключено, так как в организации есть сиделки.",
  fap_manual: "Задано администратором.",
  fap_reset: "Вернуть автоматический режим",
  fap_saved: "Сохранено",
  fap_save_failed: "Не удалось сохранить. Попробуйте ещё раз.",
  fap_pending: "Скоро",
  fap_retry: "Повторить",
  recap_title: "Утренняя ночная сводка",
  recap_desc_staff: "Каждый день в 07:00 (по времени организации) сводка прошлой ночи по каждому жильцу вашей организации.",
  recap_desc_family: "Каждый день в 07:00 (по времени организации) сводка прошлой ночи ваших близких.",
  recap_on: "Вкл.",
  recap_off: "Выкл.",
  recap_email: "Email",
  recap_telegram_link_first: "Подключите Telegram выше, чтобы получать её там.",
  recap_no_channel: "Выберите хотя бы один канал, иначе ничего не будет отправлено.",
  recap_last_sent: "Последняя отправка {at}",
  recap_saved: "Настройки сохранены.",
  recap_save_failed: "Не удалось сохранить настройки.",
  recap_unavailable: "Скоро",
  topbar_org_label: "Организация",
  device_ota_phase2: "Развёртывание OTA станет интерактивным на 2-м этапе.",
  event_window_open: "Окно открыто",
  event_window_close: "Окно закрыто",
  event_alarm_end: "Тревога завершена",
  wt_h: "ч",
  wt_load_failed: "Не удалось загрузить историю движения. Попробуйте позже.",
  recap_load_failed: "Не удалось загрузить настройки — нажмите, чтобы повторить.",
  mv_shared_note: "Этот жилец делит комнату. Комнатный датчик не различает жильцов, поэтому движение показано для комнаты, а не для одного человека.",
  mv_shared_link: "Движение в комнате {room}",
  mv_room_shared_note: "Общая для {n} жильцов — это движение нельзя приписать ни одному из них.",
  rep_shared_room_row: "Общая комната · {names}",
  admin_motion_resident: "Прикроватный датчик жильца",
  admin_motion_resident_hint: "Необязательно. Выберите жильца, только если датчик наблюдает его личное пространство (напр., направлен на кровать). Тогда его графики движения будут его использовать даже в общей комнате.",
  admin_motion_whole_room: "Вся комната",
};
export default ru;
